module.exports = __webpack_public_path__ + "static/img/癌痛护理APP软件.34b609f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/webSite/著作权/癌痛护理APP软件.png
// module id = j57a
// module chunks = 1